import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../../SiteSettingsContext';

export default function HomeMerchandisingTiles() {
  const { settings: site } = useSiteSettings();
  const store = site.store_copy || {};

  if (store.home_merchandising_enabled === false) return null;

  const tiles = (Array.isArray(store.home_merchandising_tiles) ? store.home_merchandising_tiles : []).filter(
    (t) => t?.enabled !== false && String(t?.title || '').trim() && String(t?.href || '').trim(),
  );

  if (!tiles.length) return null;

  return (
    <section className="home-merch-tiles" aria-label="Ways to shop">
      <div className="container store-page__container">
        <div className="home-merch-tiles__grid">
          {tiles.map((tile, i) => (
            <article className="home-merch-tiles__card" key={`merch-${i}-${tile.href}`}>
              {tile.icon ? (
                <span className="home-merch-tiles__icon" aria-hidden>
                  {tile.icon}
                </span>
              ) : null}
              <h2 className="home-merch-tiles__title h6">{tile.title}</h2>
              {tile.desc ? <p className="home-merch-tiles__desc">{tile.desc}</p> : null}
              <Link
                to={tile.href}
                className="btn btn-outline-primary btn-sm rounded-pill home-merch-tiles__cta"
              >
                {tile.button_label || 'Learn more'}
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
